
import { getBoard } from '@/api/myHomepageBoard';
import { IMyHomepageBoard, IMyHomepageDetail } from '@/types';
import { Vue, Component, Prop } from 'vue-property-decorator';
import HomepageBoardDetail from '@/components/homepage/board/detail.vue';

@Component({
  name: 'HomepagePost',
  components: {
    HomepageBoardDetail,
  },
})
export default class extends Vue {
  @Prop({ required: true }) detail!: IMyHomepageDetail

  mounted() {
    this.getBoard();
  }

  private board: IMyHomepageBoard | null = null;

  private getBoard() {
    getBoard(this.$route.params.boardUid).then((res) => {
      this.board = res.data;
    });
  }
}
